import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { FiUploadCloud } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import {
  UpdatecaseStudys,
  getSinglecaseStudys,
} from "../../actions/caseStudyAction";
import { useParams } from "react-router-dom";
import { mainurl } from "../../actions/mainurl";

function EditCaseStudy() {
  const { id } = useParams();
  const { SinglecaseStudy } = useSelector((state) => state.caseStudyState);
  const baseUrl = mainurl;
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [defaultImage, setDefaulImage] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [metaTitle, setMetaTitle] = useState("");
  const [description, setDescription] = useState("");
  const [metaKeyWord, setMetaKeyWord] = useState("");
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");
  const [url, setUrl] = useState("");
  const [challange, setchallage] = useState("");
  const [objective, setObjective] = useState("");
  const [solution, setSolution] = useState("");
  const [impact, setImpact] = useState("");

  // blog image
  const handleImage = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setDefaulImage(reader.result);
        setImage(e.target.files[0]);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  // category
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // react quill funtion

  const handleChallange = (e) => {
    setchallage(e);
  };
  const handleObjective = (e) => {
    setObjective(e);
  };
  const handleSolution = (e) => {
    setSolution(e);
  };
  const handleImpact = (e) => {
    setImpact(e);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("mainheading", heading);
    formData.append("case_description", content);
    formData.append("challenge_content", challange);
    formData.append("objective_content", objective);
    formData.append("solution_content", solution);
    formData.append("impact_content", impact);
    formData.append("meta_description", description);
    formData.append("meta_keywords", metaKeyWord);
    formData.append("meta_title", metaTitle);
    formData.append("imageurl", image);
    formData.append("category", selectedOption);
    formData.append("url", url);
    // Convert tags array to a string before appending it
    console.log(...formData);
    try {
      await dispatch(UpdatecaseStudys(id, formData));
    } catch (error) {
      console.error("Error creating new blog:", error);
    }
  };

  useEffect(() => {
    const loadCaseStudyCategories = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/case-study/get_category`, {
          withCredentials: true,
        });

        setAllCategory(Array.isArray(data?.allCategory) ? data.allCategory : []);
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Unable to load case study categories"
        );
      }
    };

    loadCaseStudyCategories();
    dispatch(getSinglecaseStudys(id));
  }, [baseUrl, dispatch, id]);

  useEffect(() => {
    setDefaulImage(SinglecaseStudy?.imageurl);
    setMetaTitle(SinglecaseStudy?.meta_title);
    setDescription(SinglecaseStudy?.meta_description);
    setMetaKeyWord(SinglecaseStudy?.meta_keywords);
    setHeading(SinglecaseStudy?.mainheading);
    setContent(SinglecaseStudy?.case_description);
    setUrl(SinglecaseStudy?.url);
    setchallage(SinglecaseStudy?.challenge_content);
    setObjective(SinglecaseStudy?.objective_content);
    setSolution(SinglecaseStudy?.solution_content);
    setImpact(SinglecaseStudy?.impact_content);
    setSelectedOption(SinglecaseStudy?.category);
  }, [SinglecaseStudy]);

  return (
    <div className="create_main_div">
      <div className="create_div">
        <form onSubmit={handleSubmit} className="create_div">
          <div className="input_div">
            <div className="input_name">case Study Image</div>
            <label htmlFor="image" className="custom-file-input">
              {
                <img
                  style={{ position: "relative", zIndex: "5" }}
                  src={image ? defaultImage : defaultImage}
                  alt=""
                />
              }
              <FiUploadCloud className="upload_icon" />
            </label>
            <input
              type="file"
              onChange={handleImage}
              name="image"
              id="image"
              style={{ display: "none" }}
            />
          </div>

          <div className="input_div">
            <div className="input_name">Category</div>
            <select
              className="create_input"
              value={selectedOption}
              onChange={handleOptionChange}
            >
              <option value="">Select page</option>
              {allCategory?.map((item) => (
                <option key={item._id || item.categories} value={item.categories}>
                  {item.categories}
                </option>
              ))}
            </select>
          </div>
          <div className="input_div">
            {selectedOption ? (
              <>
                {" "}
                <div className="input_name">Create a Category</div>
                <input
                  className="create_input"
                  type="text"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                />
              </>
            ) : (
              <>
                <div className="input_name">Create a Category</div>
                <input
                  className="create_input"
                  type="text"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                />
              </>
            )}
          </div>
          <div className="input_div">
            <div className="input_name">Url</div>
            <input
              className="create_input"
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <div className="input_div">
            <div className="input_name">Meta Title</div>
            <input
              className="create_input"
              type="text"
              // placeholder="Enter the meta_title"
              value={metaTitle}
              onChange={(e) => setMetaTitle(e.target.value)}
            />
          </div>
          <div className="input_div">
            <div className="input_name">Meta Description</div>
            <input
              className="create_input"
              type="text"
              // placeholder="Enter The meta_description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="input_div">
            <div className="input_name">Meta Keyword</div>
            <input
              className="create_input"
              type="text"
              // placeholder="Enter The meta_keywords"
              value={metaKeyWord}
              onChange={(e) => setMetaKeyWord(e.target.value)}
            />
          </div>
          <div className="input_div">
            <div className="input_name">Case Study Title</div>
            <input
              className="create_input"
              type="text"
              // placeholder="Enter The Heading"
              value={heading}
              onChange={(e) => setHeading(e.target.value)}
            />
          </div>
          <div className="input_div">
            <div className="input_name">Case Study description</div>
            <textarea
              className="create_text_area"
              type="text"
              // placeholder="Enter some Content..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </div>
          <div className="input_div">
            <div className="input_name">Challenge description</div>
            <ReactQuill
              className="text_area"
              placeholder="write some thing"
              formats={EditCaseStudy.formats}
              modules={EditCaseStudy.modules}
              value={challange}
              onChange={handleChallange}
            />
          </div>
          <div className="input_div" style={{ marginTop: "60px" }}>
            <div className="input_name">Objective description</div>
            <ReactQuill
              className="text_area"
              placeholder="write some thing"
              formats={EditCaseStudy.formats}
              modules={EditCaseStudy.modules}
              value={objective}
              onChange={handleObjective}
            />
          </div>
          <div className="input_div" style={{ marginTop: "60px" }}>
            <div className="input_name">Solution description</div>
            <ReactQuill
              className="text_area"
              placeholder="write some thing"
              formats={EditCaseStudy.formats}
              modules={EditCaseStudy.modules}
              value={solution}
              onChange={handleSolution}
            />
          </div>
          <div className="input_div" style={{ marginTop: "60px" }}>
            <div className="input_name">Impact description</div>
            <ReactQuill
              className="text_area"
              placeholder="write some thing"
              formats={EditCaseStudy.formats}
              modules={EditCaseStudy.modules}
              value={impact}
              onChange={handleImpact}
            />
          </div>
          <div className="submit_buttons">
            <input
              type="submit"
              value={"submit"}
              className="create_input_button"
            />
          </div>
        </form>
      </div>
    </div>
  );
}

EditCaseStudy.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};
EditCaseStudy.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "video",
  "image",
  "code-block",
  "align",
];

export default EditCaseStudy;
